import { FunctionComponent } from 'react'
import { Avatar, Text } from '@conexasaude/conexa-hero'
import Icon from '@/components/RebrandedHeroIcons'
import { useStyles } from './styles'
import { RenderIf } from '../RenderIf'
import { ProfessionalAvatarProps } from './types'

const ProfessionalAvatar: FunctionComponent<
  ProfessionalAvatarProps
> = props => {
  const {
    picture,
    name = 'Aguardando definição',
    speciality,
    withArrow,
  } = props

  const styles = useStyles()

  return (
    <div css={styles.wrapper}>
      <div css={styles.content}>
        <Avatar src={picture} alt={name} size="medium" />

        <div css={styles.professionalInfo}>
          <Text variant="headingSmall">{name}</Text>

          <RenderIf condition={!!speciality}>
            <Text renderAs="span" variant="paragraphSmall">
              {speciality}
            </Text>
          </RenderIf>
        </div>
      </div>

      <RenderIf condition={withArrow}>
        <Icon name="arrow-right" css={styles.arrowIcon} />
      </RenderIf>
    </div>
  )
}

export { ProfessionalAvatar }
